import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "../services/auth.api.ts";  
import { ticketsApi } from "../services/ticket.api.ts";  
import { categoryApi } from "../services/category.api.ts";
import { ticket_typeApi } from "../services/ticket_type.api.ts";
import { clientApi } from "../services/client.api.ts";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { agentApi } from "../services/agent.api.ts";
import authReducer from "../features/authSlice.ts"

export const store = configureStore({
  reducer: {
    auth: authReducer, 
    [authApi.reducerPath]: authApi.reducer,  
    [ticketsApi.reducerPath]: ticketsApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [ticket_typeApi.reducerPath]: ticket_typeApi.reducer,
    [clientApi.reducerPath]: clientApi.reducer,
    [agentApi.reducerPath]: agentApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(ticketsApi.middleware)
      .concat(categoryApi.middleware)
      .concat(ticket_typeApi.middleware)
      .concat(clientApi.middleware)
      .concat(agentApi.middleware),    
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
setupListeners(store.dispatch);